import React from 'react'
import { DateInput } from "@blueprintjs/datetime";
import './index.css'
import MomentLocaleUtils from "react-day-picker/moment";
import "moment/locale/es";
import { formatDateObject, getDatePlaceholder, parseApiCivilDate, parseDisplayDate } from 'Utilities/dateTime'

export default (props) =>{
    let value = null
    if(props.value){
        value = parseApiCivilDate(props.value)
    }

    return <DateInput 
                    formatDate={formatDateObject}
                    parseDate={parseDisplayDate}
                    placeholder={getDatePlaceholder()}
                    locale="es" localeUtils={MomentLocaleUtils}
                    {...props}
                    value={value}
                />
}